import { createFileRoute } from '@tanstack/react-router';

import type { PreviewOrigin } from '@/features/gap-review/components/AppPreviewView';
import {
  AppPreviewView,
  isPreviewOrigin,
} from '@/features/gap-review/components/AppPreviewView';

/** Exported so `routeTree.gen.ts` can name it under declaration emit. */
export interface GapPreviewSearch {
  from: PreviewOrigin;
}

export const Route = createFileRoute('/_dashboard/gap-review/preview/$draftId')(
  {
    component: AppPreviewRoute,
    /**
     * Where Back returns to. It is in the URL rather than in component state
     * because the preview is a real route: a reviewer can reload it, and landing
     * back in the reader when they came from final review would be wrong.
     */
    validateSearch: (search: Record<string, unknown>): GapPreviewSearch => ({
      from: isPreviewOrigin(search.from) ? search.from : 'reader',
    }),
  }
);

function AppPreviewRoute() {
  const { draftId } = Route.useParams();
  const { from } = Route.useSearch();

  return <AppPreviewView draftId={draftId} from={from} key={draftId} />;
}
